<div class="h-100">
  <div class="row h-100 no-gutters">
    <div class="d-none d-lg-block col-lg-4">
      <div class="slider-light">
        <ngx-slick-carousel class="slick-slider slick-dotted" #slickModal="slick-carousel" [config]="slideConfig2">
          <div ngxSlickItem>
            <div class="position-relative h-100 d-flex justify-content-center align-items-center bg-plum-plate">
              <div class="slide-img-bg" style="background-image: url('assets/images/scamp/scamp01.jpg');"></div>
              <div class="slider-content text-light">
                <h3>Gestão de Manutenção</h3>
                <p>
                  Faça a gestão das solicitações de providências ou de Plano básico de Manutenção de forma eficiente.
                </p>
              </div>
            </div>
          </div>
          <div ngxSlickItem>
            <div class="position-relative h-100 d-flex justify-content-center align-items-center bg-premium-dark">
              <div class="slide-img-bg" style="background-image: url('assets/images/scamp/scamp02.jpg');"></div>
              <div class="slider-content text-light">
                <h3>Controle de OSs</h3>
                <p>
                  Gere Ordens de Serviços e controle todo o ciclo de vida delas
                </p>
              </div>
            </div>
          </div>
          <div ngxSlickItem>
            <div class="position-relative h-100 d-flex justify-content-center align-items-center bg-sunny-morning">
              <div class="slide-img-bg opacity-6" style="background-image: url('assets/images/scamp/scamp01.jpg');">
              </div>
              <div class="slider-content text-light">
                <h3>Relatórios Gerencias</h3>
                <p>
                  Gere relatórios gerenciais de tomadas de decisão com base nas informações inseridas
                </p>
              </div>
            </div>
          </div>
        </ngx-slick-carousel>
      </div>
    </div>
    <div class="h-100 d-flex bg-white justify-content-center align-items-center col-md-12 col-lg-8">
      <div class="mx-auto app-login-box col-sm-12 col-md-10 col-lg-9 text-center">

        <h3 class="text-primary text-uppercase">Sigem Cloud</h3>
        <h6 class="text-muted">Sistema de Controle Automático de Manutenção</h6>

        <div class="mt-4 mb-4">
          <h6 class="text-muted"><span [innerHtml]="msgTelaLogin"></span></h6>
        </div>

        <div class="divider row mb-3"></div>        
        <h5 class="mb-4">
          <span class="mr-5">Controle de acesso</span>
          
          <span>{{nomeCliente}}</span>
        </h5>

        <div>
          <form novalidate [formGroup]="form" (validSubmit)="submit()">

            <div class="form-row">
              <div class="form-group offset-md-3 col-md-6">
                <div class="input-group flex-nowrap">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fa fa-user"></i></span>
                  </div>
                  <input formControlName="username" type="text" class="form-control" placeholder="login" maxlength="20">
                </div>
                <section *ngIf="!form.valid" class="form-text text-danger pl-2">
                  <small *ngIf="form.get('username').hasError('isNotValidUserName')">O login deve ser informado</small>
                </section>
              </div>
            </div>

            <div class="form-row mb-3">
              <div class="form-group offset-md-3 col-md-6">
                <div class="input-group flex-nowrap">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fa fa-lock"></i></span>
                  </div>
                  <input formControlName="password" type="password" class="form-control" placeholder="senha">
                </div>
                <section *ngIf="!form.valid" class="form-text text-danger pl-2">
                  <small *ngIf="form.get('password').hasError('isNotValidPassword')">A senha deve ser informada</small>
                </section>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group offset-md-3 col-md-6">
                <button class="btn btn-primary btn-block ball-clip-rotate" (click)="submit()">Acessar</button>
              </div>
            </div>

            <div *ngIf="acessando" class="loader-wrapper d-flex justify-content-center align-items-center">
              <div class="loader">
                <div class="ball-clip-rotate">
                  <div></div>
                </div>
              </div>
            </div>

          </form>
          <section *ngIf="msgUsuarioDesativado != ''" class="form-text text-danger pl-2 fb animated fadeInDown">
            {{ msgUsuarioDesativado }}
          </section>

          <div class="divider row"></div>

          <div class="row">
            <div class="col-md-5">
              <span class="d-flex justify-content-start mb-2">versão 1.0.0.0</span>
              <span class="d-flex justify-content-start">{{nomeCliente}}</span>
            </div>
            <div class="col-md-5">
              <span class="d-flex justify-content-end mb-2">
                <a href="http://www.herainfor.com.br" target="_blank">www.herainfor.com.br</a>
              </span>

              <span class="d-flex justify-content-end">{{parceiroComercial}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>